import { FC } from "react"

interface ColumnTagProps {
  title: string
}

const ColumnTag: FC<ColumnTagProps> = ({ title }) => (
  <span className="border border-[#E2E8F0] rounded-full px-2 py-1 text-sm">
    {title}
  </span>
)

export default ColumnTag
